import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import Action from '../../../../components/Section/Action';
import svg from '../../../../static/img/icon-open-menu.svg';
import { Categories, Actions, Labels } from '../../../../types/gtm';
import { useAuth } from '../../../../hooks/useAuth';

const BoxCommuncationPreferences = () => {
  const { user } = useAuth();

  const title = 'Gestão de Comunicados';
  const describeTitle = 'Gerencie os comunicados que você recebe da Globo';
  return (
    <Box title={title} describeTitle={describeTitle}>
      <Content>
        <Action
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Home,
              event_action: Actions.ClickComunicationPreferences,
              event_label: Labels.Home,
              bd_suser_code: user?.globoId,
            });
          }}
          to="/gestao-comunicados"
          theme="link"
        >
          <p>Controlar Comunicados</p>
          <Icon svg={svg} alt="icon-open-menu" />
        </Action>
      </Content>
    </Box>
  );
};

export default BoxCommuncationPreferences;
